import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "../Pages/HomePage";
import MarketingLanding from "../Pages/MarketingLanding";
import EmployeeLogin from "../Pages/EmployeeLogin";
import ConsultantLogin from "../Pages/ConsultantLogin";
import SystemLogin from "../Pages/SystemLogin.jsx";
import ResetPassword from "../Pages/ResetPassword.jsx";

const AuthRoutes = () => {
	return (
		<Routes>
			<Route path="/" element={<MarketingLanding />} />
			<Route path="/Employee-Login" element={<EmployeeLogin />} />
			<Route path="/Consultant-Login" element={<ConsultantLogin />} />
			<Route path="/System-Login" element={<SystemLogin />} />
			<Route path="/Reset-Password/:uid" element={<ResetPassword />} />
		</Routes>
	);
};

export default AuthRoutes;
